import React from "react";

export const ForgotPassword = () => {
  return <h3>This is ForgotPassword</h3>
}
